import service from '../utils/request';

// 获取提现申请分页列表
export const getWithdrawApplicationList = (params) => {
  console.log(params);
  return service.get('/withdraw-applications/list', { params });
};

// 获取提现申请详情
export const getWithdrawApplicationDetail = (id) => {
  return service.get(`/withdraw-applications/${id}`);
};

// 审核提现申请
export const reviewWithdrawApplication = (id, data) => {
  return service.post(`/withdraw-applications/${id}/review`, null, { params: data });
};

// 处理提现转账
export const processWithdrawTransfer = (id, data) => {
  return service.post(`/withdraw-applications/${id}/transfer`, null, { params: data });
};

// ========== 提现配置相关接口 ==========

// 分页查询全局提现配置
export const getWithdrawConfigPage = (params) => {
  return service.get('/withdraw-config/page', { params });
};

// 根据账户类型查询提现配置
export const getWithdrawConfigByAccountType = (accountType) => {
  return service.get(`/withdraw-config/account-type/${accountType}`);
};

// 创建全局提现配置
export const createWithdrawConfig = (data) => {
  return service.post('/withdraw-config', data);
};

// 更新全局提现配置
export const updateWithdrawConfig = (configId, data) => {
  return service.put(`/withdraw-config/${configId}`, data);
};

// 删除全局提现配置
export const deleteWithdrawConfig = (configId) => {
  return service.delete(`/withdraw-config/${configId}`);
};

// ========== 用户提现配置相关接口 ==========

// 分页查询用户提现配置
export const getUserWithdrawConfigPage = (params) => {
  return service.post('/user-withdraw-config/page', params );
};

// 根据用户ID查询提现配置
export const getUserWithdrawConfigsByUserId = (userId) => {
  return service.get(`/user-withdraw-config/user/${userId}`);
};

// 为用户创建提现配置
export const createUserWithdrawConfig = (userId, data) => {
  return service.post(`/user-withdraw-config/user/${userId}`, data);
};

// 更新用户提现配置
export const updateUserWithdrawConfig = (configId, data) => {
  return service.put(`/user-withdraw-config/${configId}`, data);
};

// 删除用户提现配置
export const deleteUserWithdrawConfig = (configId) => {
  return service.delete(`/user-withdraw-config/${configId}`);
}; 